import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  label: 'Drag and drop or',
  subLabel: 'select a photo from your computer',
})
